import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-placeholder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './placeholder.component.html'
})
export class PlaceholderComponent implements OnInit {
  @Input() pageTitle: string = 'Coming Soon';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe(data => {
      if (data['pageTitle']) {
        this.pageTitle = data['pageTitle'];
      }
    });
  }

  goHome() {
    window.location.href = '/';
  }

  contactUs() {
    // Scroll to contact section on home page or open contact modal
    window.location.href = '/#contact';
  }
}
